module.exports = __webpack_public_path__ + "static/media/manufacturer1.90dbc638.png";